import { render, staticRenderFns } from "./jtxx.vue?vue&type=template&id=3313413f"
import script from "./jtxx.vue?vue&type=script&lang=js"
export * from "./jtxx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports